import { Discont, DiscontStatus, ID } from "@project/shared-types";
import { useEffect, useState } from "react";
import { getDiscontsAPI } from "../../model/discont.api";
import { DiscontCard } from "../PersonDiscont/DiscontCard";

interface IDiscontsView {
  discont: Discont | undefined;
  setDiscont: React.Dispatch<React.SetStateAction<Discont | undefined>>;
  isUpdateDisconts: boolean;
  setIsUpdateDisconts: React.Dispatch<React.SetStateAction<boolean>>;
  email: string;
  global_id: string | undefined;
}
export const DiscontsView = ({
  email,
  discont,
  setDiscont,
  isUpdateDisconts,
  setIsUpdateDisconts,
  global_id,
  ...props
}: IDiscontsView) => {
  const [disconts, setDisconts] = useState<Discont[]>([]);

  const getDisconts = async () => {
    try {
      const response = await getDiscontsAPI();

      if (response.disconts) {
        setDisconts(response.disconts);
        setIsUpdateDisconts(false);
      }
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };
  useEffect(() => {
    if (isUpdateDisconts) getDisconts();
  }, [isUpdateDisconts]);
  const handleActiveDiscont = (id: ID) => {
    const updatedDisconts = disconts.map((discont) => {
      if (discont.id === id) {
        if (discont.status === "wait") {
          setDiscont(discont);
          return { ...discont, status: "ok" as DiscontStatus };
        } else {
          setDiscont(undefined);

          return { ...discont, status: "wait" as DiscontStatus };
        }
      }
      return { ...discont, status: "wait" as DiscontStatus };
    });

    // Обновляем состояние disconts с новым массивом updatedDisconts
    setDisconts(updatedDisconts);
  };
  const isActiveDiscont = (discont: Discont) => {
    if (discont.status === "ok") return true;
    return false;
  };
  return (
    <>
      {disconts.length != 0 && (
        <div className="new-payment-disconts">
          {disconts.map((discont, index) => (
            <DiscontCard
              key={discont.id}
              discont={discont}
              isActive={isActiveDiscont(discont)}
              is_green={false}
              handleClick={handleActiveDiscont}
            ></DiscontCard>
          ))}
        </div>
      )}
    </>
  );
};
